import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useRef } from 'react';
export const OtpInput = ({ value, onChange, length = 6, hasError = false, disabled = false, autoFocus = true, dataTestId = 'otp-input', }) => {
    const inputRefs = useRef([]);
    const digits = value.split('').concat(Array(length).fill('')).slice(0, length);
    const focusInput = (index) => {
        if (index >= 0 && index < length) {
            inputRefs.current[index]?.focus();
        }
    };
    const handleChange = (index, e) => {
        const inputValue = e.target.value;
        if (!/^\d*$/.test(inputValue)) {
            return;
        }
        const digit = inputValue.slice(-1);
        const newValue = value.split('');
        newValue[index] = digit;
        const result = newValue.join('').slice(0, length);
        onChange(result);
        if (digit && index < length - 1) {
            focusInput(index + 1);
        }
    };
    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace') {
            e.preventDefault();
            const newValue = value.split('');
            if (newValue[index]) {
                newValue[index] = '';
                onChange(newValue.join(''));
            }
            else if (index > 0) {
                newValue[index - 1] = '';
                onChange(newValue.join(''));
                focusInput(index - 1);
            }
        }
        else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            focusInput(index - 1);
        }
        else if (e.key === 'ArrowRight') {
            e.preventDefault();
            focusInput(index + 1);
        }
    };
    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, length);
        if (pastedData) {
            onChange(pastedData);
            focusInput(Math.min(pastedData.length, length - 1));
        }
    };
    const handleFocus = (e) => {
        e.target.select();
    };
    const inputClass = classNames('w-[3rem] h-[3.25rem] text-center text-lg font-medium rounded-lg border-2 outline-none transition-colors', 'focus:border-purple-500 focus:ring-1 focus:ring-purple-500', {
        'border-red-400 bg-red-50': hasError,
        'border-neutral-300 bg-white': !hasError,
        'opacity-50 cursor-not-allowed': disabled,
    });
    return (_jsx("div", { className: 'flex gap-3 justify-center', "data-testid": dataTestId, children: digits.map((digit, index) => (_jsx("input", { ref: (el) => {
                inputRefs.current[index] = el;
            }, type: 'text', inputMode: 'numeric', maxLength: 1, value: digit, onChange: (e) => handleChange(index, e), onKeyDown: (e) => handleKeyDown(index, e), onPaste: handlePaste, onFocus: handleFocus, disabled: disabled, autoFocus: autoFocus && index === 0, className: inputClass, "data-testid": `${dataTestId}-${index}`, "aria-label": `Digit ${index + 1}` }, index))) }));
};
